import { Pipe, PipeTransform } from '@angular/core';
import { CountriesService } from '@zero/onboarding/domain';
import { AtAlgorithm, ChAlgorithm, DeAlgorithm } from '@zero/shared/util-form-validators';

@Pipe({
  name: 'tinError',
  standalone: true,
})
export class TinErrorPipe implements PipeTransform {
  constructor(public readonly countriesService: CountriesService) {}

  public transform(value: string, country: string): string | null {
    if (!value || !country) {
      return null;
    }

    const isKnownTinValidationCountry = ['DE', 'AT', 'CH'].includes(country);
    if (isKnownTinValidationCountry) {
      return this.#validateCountryTin(value, country);
    }

    if (this.countriesService.isoCodesEU.includes(country)) {
      // zwischen 8 u. 16 Zeichen, Buchstaben, Ziffern, Schrägstrich, Bindestrich
      if (!RegExp(/[A-Za-z0-9\-/]{8,16}/).exec((value || '').trim())) {
        return 'onboarding.error.tin.invalidLength';
      }
    }

    return null;
  }

  #validateCountryTin(tin: string, country: string): string | null {
    if (!tin) {
      return null;
    }

    switch (country) {
      case 'DE':
        return new DeAlgorithm().validate(tin);
      case 'AT':
        return new AtAlgorithm().validate(tin);
      case 'CH':
        return new ChAlgorithm().validate(tin);
      default:
        return null;
    }
  }
}
